import { render, staticRenderFns } from "./CardApontamento.vue?vue&type=template&id=384aa818&scoped=true"
import script from "./CardApontamento.vue?vue&type=script&lang=js"
export * from "./CardApontamento.vue?vue&type=script&lang=js"
import style0 from "./CardApontamento.vue?vue&type=style&index=0&id=384aa818&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384aa818",
  null
  
)

export default component.exports